import Reveal from "@/components/base/Reveal";

const steps = [
  {
    img: "https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/51ecb72f-6136-498d-be41-6e707abbc805_compressed_Frame-1000000998.webp",
    title: "Публікуєте вакансію",
    text: "Розміщуєте вакансію на OLX Робота та пов'язуєте її з вакансією в HURMA.",
  },
  {
    img: "https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/60902cfc-ec9c-4278-b3ab-e68d05f580fa_compressed_Frame-1000000998-1.webp",
    title: "Отримуєте відгуки",
    text: "Відгуки автоматично потрапляють у HURMA — без ручного перенесення.",
  },
  {
    img: "https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/964c214d-5c0a-4ba7-9f95-fc87a79a2462_compressed_Frame-1000001001.webp",
    title: "Наймаєте співробітника",
    text: "Той самий кандидат стає тим самим співробітником.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="scroll-mt-16 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-24 md:px-6 md:py-32">
        <div className="text-center">
          <Reveal delay={100}>
            <h2 className="mt-4 font-heading text-4xl font-extrabold leading-tight tracking-tight md:text-6xl">
              <span className="peach-gradient-text">Клік-клік і вакансія закрита</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-10 md:mt-24 md:grid-cols-3 md:gap-12">
          {steps.map((step, i) => (
            <Reveal key={i} delay={i * 150}>
              <div className="relative text-center">
                <img
                  src={step.img}
                  alt={step.title}
                  className="mx-auto w-full max-w-sm rounded-lg object-contain"
                />
                <h3 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">
                  {step.title}
                </h3>
                <p className="mx-auto mt-3 max-w-sm text-base leading-relaxed text-foreground-600 md:text-lg">
                  {step.text}
                </p>

                {i < steps.length - 1 && (
                  <div className="absolute -right-10 top-24 hidden -translate-y-1/2 text-primary-400 md:block">
                    <i className="ri-arrow-right-line text-3xl"></i>
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}